import { Button, Modal, message } from "antd";
import { useEffect } from "react";
import config from "../../../config";
const base_url = config.base_url;
function DeletePartnerModal({
  onCancel,
  onOk,
  userName,
  userId,
  open,
  setData,
  setFilteredData,
  closeModal,
}) {
  const [messageApi, contextHolder] = message.useMessage();
  const success = () => {
    messageApi.open({
      type: "success",
      content: "Partner Deleted Successfully",
    });
  };
  const handleDeletePartner = async () => {
    if (!userId) return;
    onOk();
    success();

    await fetch(base_url + "admin/partners/delete/partner", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, /",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `partner_id=${userId}`,
    })
      .then((res) => {
        fetch(`${base_url}admin/partners/data`, {
          method: "POST",
          mode: "cors",
          body: ``,
          titles: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
        })
          .then((res) => res.json())
          .then((res) => {
            const data = res.data.map((user) => {
              const day = new Date(res.data[0].date).getMonth() + 1;
              const month = new Date(res.data[0].date).getDate();
              const year = new Date(res.data[0].date).getFullYear();

              return { ...user, date: `${year}-${month}-${day}` };
            });

            setData(data);
            setFilteredData(data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Modal
      className="deleteModal"
      closeIcon={false}
      open={open}
      onCancel={(e) => {
        onCancel();
      }}
      onOk={(e) => {
        onOk();
      }}
      footer={[
        <Button
          style={{
            width: "83px",
            height: "41px",
          }}
          key="cancel"
          onClick={onCancel}
          className="cancelButton"
        >
          Cancel
        </Button>,
        <Button
          onClick={(e) => {
            handleDeletePartner();
          }}
          key={"delete"}
          className="deletePartnerButton"
        >
          Delete
        </Button>,
      ]}
    >
      <div className="deleteModalContent">
        {" "}
        {contextHolder}
        <h3>Are You Sure You Want To Delete {userName}?</h3>
      </div>
    </Modal>
  );
}
export default DeletePartnerModal;
